import { Modal } from "react-bootstrap";
import { DocumentDismissModalProps } from "./Document.types";

export function DocumentDismissModal({
  show,
  onCancel,
  onDismiss,
}: DocumentDismissModalProps) {
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Delete document
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this document? This action is
        irreversible.
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={onDismiss}>
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
}
